/**
 * This service is responsible to manage the view, display/hide, disable/enable
 * @param integrationConstant static data
 * @returns {*}
 */
function integrationViewService(integrationConstant) {
    const isMerchantAdminLocation = (location) => {
        return location === integrationConstant.LOCATION.merchantAdmin.label;
    };
    const isOutletAdminLocation = (location) => {
        return location === integrationConstant.LOCATION.outletAdmin.label;
    };
    return {
        isIntegrationSetAvailableForBizCat(businessCategoryName) {
            //const NOT_AVAILABLE_CATEGORIES = ['School', 'University', 'Supplier', 'Charity', 'Vending'];
            //return !NOT_AVAILABLE_CATEGORIES.includes(businessCategoryName);
            return false;
        },
        getFulfillmentDisplay(location) {
            return {
                collection: {
                    toggle: {
                        disabled: true,
                        display: true
                    },
                    collectionWithTimeSlots: {
                        disabled: false,
                        display: true
                    },
                    intervalAndPreparationTime: {
                        disabled: false,
                        display: isMerchantAdminLocation(location) || isOutletAdminLocation(location)
                    },
                    referenceMenu: {
                        disabled: false,
                        display: false
                    },
                    warningTimeSlot: {
                        disabled: false,
                        display: false
                    },
                    syncMenu: {
                        disabled: false,
                        display: false
                    },
                    paymentezAppKey: {
                        disabled: false,
                        display: false
                    },
                    timeWindowInputs: {
                        disabled: false,
                        display: isOutletAdminLocation(location)
                    },
                    isTakeAwayMenuSync: {
                        disabled: false,
                        display: false
                    }
                }
            };
        },
        // externalImpact, the component behaviour depends on external actions, parent components state,
        // component state and parent data(outlet case)
        getPayAtTableDisplay(externalImpact) {
            // parentComponentRules are the posComponent or fulfilment component rules, a pos micros could tell to the
            // toggle to be on or off depends on its rule
            const parentComponentRules = externalImpact.parentComponentRules;
            const actions = externalImpact.siblingsComponent;
            // isUseMerchantSettings it means useMerchantSettings is true
            const isUseMerchantSettings = externalImpact.isUseMerchantSettings;

            return {
                // TODO rename toggle
                toggle: {
                    // It need disable only the one that should not pick(YES or NO),
                    // if disable both it needs to change the css
                    disabled: isUseMerchantSettings || parentComponentRules.toggle.disabled,
                    display: parentComponentRules.toggle.display
                },
                securityCode: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.securityCode.display
                },
                subFeature: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.subFeature.display && actions.payAtTable
                },
                orderAtTable: {
                    disabled: isUseMerchantSettings || parentComponentRules.orderAtTable.disabled,
                    display: parentComponentRules.orderAtTable.display && actions.payAtTable
                },
                orderAtTableSubFeature: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.orderAtTableSubFeature.display &&
                     actions.payAtTable && actions.orderAtTable
                },
                orderAtTablePosMenuRef: {
                    disabled: parentComponentRules.orderAtTablePosMenuRef.disabled,
                    display: parentComponentRules.orderAtTablePosMenuRef.display
                },
                posUrl: {
                    disabled: parentComponentRules.posUrl.disabled,
                    display: parentComponentRules.posUrl.display
                },
                omnivoreEmployeeId: {
                    disabled : parentComponentRules.omnivoreEmployeeId.disabled,
                    display: parentComponentRules.omnivoreEmployeeId.display
                },
                omnivorePatOrderTypeId: {
                    disabled : parentComponentRules.omnivorePatOrderTypeId.disabled,
                    display: parentComponentRules.omnivorePatOrderTypeId.display
                },
                omnivoreRevenueCenterId: {
                    disabled : parentComponentRules.omnivoreRevenueCenterId.disabled,
                    display: parentComponentRules.omnivoreRevenueCenterId.display
                },
                omnivoreTenderTypeId: {
                    disabled : parentComponentRules.omnivoreTenderTypeId.disabled,
                    display: parentComponentRules.omnivoreTenderTypeId.display
                },
                webhookId: {
                    disabled : parentComponentRules.webhookId.disabled,
                    display: parentComponentRules.webhookId.display
                },
                usePaymentType: {
                    disabled : parentComponentRules.usePaymentType.disabled,
                    display: parentComponentRules.usePaymentType.display && actions.payAtTable
                }
            };
        },
        getBarTabDisplay(externalImpact) {
            // parentComponentRules are the posComponent or fulfilment component rules, a pos micros could tell to the
            // toggle to be on or off depends on its rule
            const parentComponentRules = externalImpact.parentComponentRules;
            const actions = externalImpact.siblingsComponent;
            // isUseMerchantSettings it means useMerchantSettings is true
            const isUseMerchantSettings = externalImpact.isUseMerchantSettings;
            return {
                toggle: {
                    // It need disable only the one that should not pick(YES or NO),
                    // if disable both it needs to change the css
                    disabled: isUseMerchantSettings || parentComponentRules.toggle.disabled,
                    display: parentComponentRules.toggle.display
                },
                subFeature: {
                    disabled: isUseMerchantSettings || parentComponentRules.subFeature.disabled,
                    display: parentComponentRules.subFeature.display && actions.barTab
                }
            };
        },
        getCollectionDisplay(externalImpact) {
            // parentComponentRules are the posComponent or fulfilment component rules, a pos micros could tell to the
            // toggle to be on or off depends on its rule
            // the state of the parent impacts on the child.
            const parentComponentRules = externalImpact.parentComponentRules;
            const actions = externalImpact.siblingsComponent;
            // isUseMerchantSettings it means useMerchantSettings is true
            const isUseMerchantSettings = externalImpact.isUseMerchantSettings;

            return {
                toggle: {
                    // It need disable only the one that should not pick(YES or NO),
                    // if disable both it needs to change the css
                    disabled: isUseMerchantSettings || parentComponentRules.toggle.disabled,
                    display: parentComponentRules.toggle.display
                },
                collectionWithTimeSlots: {
                    disabled: isUseMerchantSettings || parentComponentRules.collectionWithTimeSlots.disabled,
                    display: parentComponentRules.collectionWithTimeSlots.display &&
                        actions.collection
                },
                intervalAndPreparationTime: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.intervalAndPreparationTime.display &&
                        actions.collectionWithTimeSlots &&
                        actions.collection
                },
                referenceMenu: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.referenceMenu.display &&
                        actions.collectionWithTimeSlots &&
                        actions.collection
                },
                warningTimeSlot: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.warningTimeSlot.display &&
                        actions.collectionWithTimeSlots &&
                        actions.collection
                },
                syncMenu: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.syncMenu.display &&
                             actions.collection
                },
                paymentezAppKey: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.paymentezAppKey.display &&
                        actions.collection
                },
                timeWindowInputs: {
                    disabled: isUseMerchantSettings || false,
                    display: parentComponentRules.timeWindowInputs.display &&
                        actions.collectionWithTimeSlots &&
                        actions.collection
                },
                isTakeAwayMenuSync: {
                    disabled: false,
                    display: parentComponentRules.isTakeAwayMenuSync &&
                    parentComponentRules.isTakeAwayMenuSync.display
                }
            };
        },
        getBtAndPatDisplay(options, location) {
            // isUseMerchantSettings it means useMerchantSettings(Merchant/outlets POs inheritance) is true
            const isUseMerchantSettings = options.isUseMerchantSettings;
            const isAccountManager = options.permission && options.permission.isAccountManager
            const parentComponent = options.parentComponentRules;

            return {
                toggle: {
                    // It need disable only the one that should not pick(YES or NO),
                    // if disable both it needs to change the css
                    disabled: isUseMerchantSettings,
                    display: true
                },
                checkIDLength: {
                    disabled: isUseMerchantSettings || false,
                    display: isMerchantAdminLocation(location)
                },
                posWalkoutThresholdMinutes: {
                    disabled: isUseMerchantSettings || false,
                    display: isMerchantAdminLocation(location)
                },
                autoBilling: {
                    disabled: !isAccountManager,
                    display: isMerchantAdminLocation(location)
                },
                autoBillingContactDetails: {
                    disabled: !isAccountManager,
                    display: isMerchantAdminLocation(location)
                },
                upfrontCardValidation: {
                    disabled: !isAccountManager,
                    display: isMerchantAdminLocation(location)
                },
                isBillAutoUpdate: {
                    disabled: parentComponent.isBillAutoUpdate.disabled,
                    display: parentComponent.isBillAutoUpdate.display
                }
            };
        }
    };
}
angular
    .module('qkr.integration.settings')
    .factory('integrationViewService', integrationViewService);



// WEBPACK FOOTER //
// ./src/integration-settings/services/integration.view.service.js